import SideNavigation, { SideNavigationProps } from '@amzn/awsui-components-core/side-navigation';
import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getOperationalExcellenceNavigationItems } from 'src/utilities/RouteConfig';
import { FinTechOpsHref } from '../FinTechOpsConstants';
import { Titles } from 'src/components/das-finsuite/das-finsuite-constants';

const NAV_ORDER: string[] = [
  FinTechOpsHref.oeInsights,
  FinTechOpsHref.userMetrics,
  FinTechOpsHref.tickets,
  FinTechOpsHref.kpiMetrics,
  FinTechOpsHref.costMetrics,
  FinTechOpsHref.sas,
  FinTechOpsHref.policyEngine,
  FinTechOpsHref.dogma,
  FinTechOpsHref.riskRemediator,
  FinTechOpsHref.upgradeMedic,
  FinTechOpsHref.dataMapping,
  FinTechOpsHref.oeReportGenerator,
  FinTechOpsHref.pipelineOEDashboard
];

export const OESideNavigation: React.FC = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const items = useMemo<SideNavigationProps.Item[]>(() => {
    const allItems = getOperationalExcellenceNavigationItems().filter((item): item is SideNavigationProps.Link => item.type === 'link');
    return NAV_ORDER.map((href) => allItems.find((item) => item.href === href)).filter(Boolean) as SideNavigationProps.Link[];
  }, []);

  const handleFollow: SideNavigationProps['onFollow'] = (event) => {
    event.preventDefault();
    navigate(event.detail.href);
  };

  return (
    <SideNavigation
      activeHref={pathname}
      header={{ text: Titles.TITLE_OP_EX, href: FinTechOpsHref.finTechOps }}
      items={items}
      onFollow={handleFollow}
    />
  );
};
